export default [
  { key: 'overall', display: 'Overall' },
  { key: 'attack', display: 'Attack' },
  { key: 'defense', display: 'Defense' },
  { key: 'strength', display: 'Strength' },
  { key: 'hp', display: 'HP' },
  { key: 'ranged', display: 'Ranged' },
  { key: 'prayer', display: 'Prayer' },
  { key: 'magic', display: 'Magic' },
  { key: 'cooking', display: 'Cooking' },
  { key: 'woodcutting', display: 'Woodcutting' },
  { key: 'fletching', display: 'Fletching' },
  { key: 'fishing', display: 'Fishing' },
  { key: 'firemaking', display: 'Firemaking' },
  { key: 'crafting', display: 'Crafting' },
  { key: 'smithing', display: 'Smithing' },
  { key: 'mining', display: 'Mining' },
  { key: 'herblore', display: 'Herblore' },
  { key: 'agility', display: 'Agility' },
  { key: 'thieving', display: 'Thieving' },
  { key: 'slayer', display: 'Slayer' },
  { key: 'farming', display: 'Farming' },
  { key: 'runecrafting', display: 'Runecrafting' },
  { key: 'hunter', display: 'Hunter' },
  { key: 'construction', display: 'Construction' },
];



// WEBPACK FOOTER //
// ./src/constants/statList.js